import exp from "node:constants";

export interface AuthenticateForm {
    email: string | null;
    first_name: string | null;
    last_name: string | null;
    phone_number: string | null;
    password: string | null;
    password_confirmation: string | null;
    reset_token: string | null;
    is_default_password: boolean;
    terms_agreement: boolean;
}

export const createDefaultAuthenticateForm = (): AuthenticateForm => {
    return {
        email: null,
        first_name: null,
        last_name: null,
        phone_number: null,
        password: null,
        password_confirmation: null,
        reset_token: null,
        is_default_password: true,
        terms_agreement: false,
    }
}

export interface ValidationAuthenticateStatus {
    email: boolean | null;
    first_name: boolean | null;
    last_name: boolean | null;
    phone_number: boolean | null;
    password: boolean | null;
    password_confirmation: boolean | null;
    reset_token: boolean | null;
    is_default_password: boolean | null;
    terms_agreement: boolean | null;
    [key: string]: boolean | null;
}

export const createDefaultValidationAuthenticateStatus = (): ValidationAuthenticateStatus => {
    return {
        email: false,
        first_name: false,
        last_name: false,
        phone_number: false,
        password: false,
        password_confirmation: false,
        reset_token: false,
        is_default_password: true,
        terms_agreement: false,
    }
}

export interface GenerateResetTokenResponse {
    sent: boolean;
}